import React, { useState, useEffect } from "react";
import ProfileBox from "../../Components/ProfileBox/ProfileBox";
import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import Modal from "../../Components/Modal/Modal";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CancelButton from "../../Components/Buttons/CancelButton";

import "./TeacherResume.css";
// import QualificationForm from "./QualicationForm";
import QualificationForm from "./QualicationForm.redux";
import { connect } from "react-redux";
import {
  deleteQualification,
  deleteProfessionalDevelopment,
  deleteProfessionalExperience,
  deleteRefereeCheck,
  deleteNonTeachingExperience,
} from "../../redux/homePage/homePage.actions";
import useModal from "./useModal";
import moment from 'moment'
import {displayPoliceCheckWwCC} from "../Container/HomeContainer2";
import TeacherHours from "../../Components/CountDown/TeacherHours";
import { teacherLevel } from "../../Helper";
import ImportGoogleDriveFile from "../../Components/GoogleDrive/ImportFile";
import QualificationModal from "./QualificationModal";
import DragDropFile from "../../Components/DragUpload/DragDropFile";
import { API } from "../../API";

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import { notify } from "react-notify-toast";

const TeacherResume = (props) => {
  const { user, isViewAsTeacher } = props;
  const {
    deleteQualification,
    deleteProfessionalDevelopment,
    deleteProfessionalExperience,
    deleteRefereeCheck,
    deleteNonTeachingExperience,
  } = props;

  const { isShowing, toggle } = useModal();
  const [content, setContent] = useState();
  const [qTarget, setQTarget] = useState("");
  const [qType, setQType] = useState("");
  const [isPopup, togglePopup] = useState(false);
  const [isCreate, toggleCreate] = useState(true);
  const [qualificationID, setQualificationID] = useState("");
  const [formType, setFormType] = useState("");
  const [isDeleteQuaPopup, toggleDeleteQuaPopup] = useState(false);
  // const [sortedQalifications, setQualification] = useState();
  const [certificateFile, setCertificateFile] = useState(null)
  const [transcriptFile, setTranscriptFile] = useState(null)
  const [evidenceEnrolmentFile, setEvidenceEnrolmentFile] = useState(null)
  const [isQualPopup, toggleQualPopup] = useState(false);
  const [isUploadDrive, setIsUploadDrive] = useState(false)
  const [fileFromDrive, setFileFromDrive] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  const quali_ref = React.createRef();
  const exp_ref = React.createRef();
  const referee_ref = React.createRef();

  // const QUALIFICATION_DELETE_MSG = "Qualification removed successfully";
  // const PROFESSIONAL_DEVELOPMENT_DELETE_MSG =
  //   "Professional development removed successfully";
  // const PROFESSIONAL_EXPERIENCE_DELETE_MSG =
  //   "Professional experience removed successfully";
  // const NON_TEACHING_EXPERIENCE_DELETE_MSG =
  //   "Other experience removed successfully";
  // const REFEREE_DELETE_MSG = "Referee removed successfully";

  // const showHireMe = () => {
  //   document.getElementById("modal-container-HireMe").style.display = "block";
  // };
  // const hideHireMe = () => {
  //   document.getElementById("modal-container-HireMe").style.display = "none";
  // };

  const delete_confirm = () => {
    if (qType != null) {
      if (qType === 'qualification') {
        deleteQualification(qTarget._id)
      } else if (qType === 'vet_training_quals') {
        deleteQualification({id: qTarget._id, type: 'vet_training_quals'})
      } else if (qType === 'vet_industry_quals') {
        deleteQualification({id: qTarget._id, type: 'vet_industry_quals'})
      } else if (qType === 'prof_dev') {
        deleteProfessionalDevelopment(qTarget._id)
      } else if (qType === 'tech_exp') {
        deleteProfessionalExperience(qTarget._id)
      } else if (qType === 'other_pro_exp') {
        deleteNonTeachingExperience(qTarget._id)
      } else if (qType === 'pro_refree') {
        deleteRefereeCheck(qTarget._id)
      }
    }
    toggle()
  }

  const handleChangeFileDragDrop = async (fileUpload, fileType, qualificationType) => {
    const fileName = fileUpload.name.replace(/[^\w.]/gi, "")

    switch (fileType) {
      case "certificate":
        setCertificateFile(fileUpload)
        let qualificationContent = {}
        const formData = new FormData();
        formData.append("file", fileUpload);

        try {
          setIsLoading(true)

          if (fileUpload?.type === 'application/pdf') {
            const res = await API.readTextFromFileDragDrop(formData);
            const text = res.data?.data;
          
            if (text) {
              const response = await API.readQualificationContentFromText({ data: text });
              qualificationContent = response.data?.data;
            }
          }

          setContent({
            ...content,
            certificate_filename: fileName,
            institution_name: qualificationContent?.institute || '',
            award_name: qualificationContent?.award || '',
            // graduation_date: qualificationContent?.date
          });
          setFormType("qualification");
          toggleCreate(true);
          toggleQualPopup(true);
          setIsLoading(false)
        } catch (error) {
          setContent({
            ...content,
            certificate_filename: fileName,
          });
          setFormType("qualification");
          toggleCreate(true);
          toggleQualPopup(true);
          setIsLoading(false)
          console.log('Error:', error);
        }
        break;
      case "transcript":
        setTranscriptFile(fileUpload)
        setContent({
          ...content,
          certificate_filename: fileName,
        });
        break;
      case "evidence-enrolment":
        setEvidenceEnrolmentFile(fileUpload)
        setContent({
          ...content,
          enrolment_filename: fileName,
        });
        break;
    }
  }

  const resetAllFilesUpload = () => {
    setCertificateFile(null)
    setTranscriptFile(null)
    setEvidenceEnrolmentFile(null)
  }

  const handleSelectFile = async (fileUpload, qualificationType) => {
    // setFile(fileUpload?.fileId)

    let qualificationContent = {}

    try {
      setIsLoading(true)

      if (fileUpload?.mimeType === 'application/pdf') {
        const res = await API.readTextFromGoogleDriveFile(fileUpload);
        const text = res.data?.data;
      
        if (text) {
          const response = await API.readQualificationContentFromText({ data: text });
          qualificationContent = response.data?.data;
        }
      }

      setContent({
        certificate_filename: fileUpload.fileName,
        institution_name: qualificationContent?.institute || '',
        award_name: qualificationContent?.award || '',
        // graduation_date: qualificationContent?.date
      });

      setIsUploadDrive(true)
      setFileFromDrive(fileUpload)
      setFormType("qualification");
      toggleCreate(true);
      toggleQualPopup(true)
      setIsLoading(false)
    } catch (error) {
      setContent({
        certificate_filename: fileUpload.name,
      });
      setIsUploadDrive(true)
      setFileFromDrive(fileUpload)
      setFormType("qualification");
      toggleCreate(true);
      toggleQualPopup(true)
      setIsLoading(false)
      console.log('Error:', error);
    }
  }

  const showShareProfile = () => {
    setFormType("shareProfile");
    setContent("");
    togglePopup(true);
  };

  const showAddQualifications = () => {
    setContent("");
    setFormType("qualification");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(false)
  };

  const showAddReferee = (q) => {
    if (q) {
      setContent(q);
    } else {
      setContent("");
    }
    setFormType("referee");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(false)
  };

  const editAddQualifications = (q) => {
    setContent(q);
    setFormType("qualification");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(true)
  };
  /*  const showEditQualifications = (e) => {
      setFormType('qualification')
      togglePopup(true)
      toggleCreate(false)
      setQualificationID(e.target.getAttribute('value') || e.target.parentNode.getAttribute('value'))
    }*/

  const toggleDeleteQualification = (e) => {
    // assign the qualificationId and pass it to delete popup
    setQualificationID(e.target.parentNode.getAttribute("value"));
    toggleDeleteQuaPopup(true);
  };

  const showAddPD = () => {
    setContent("");
    setFormType("PD");
    toggleCreate(true);
    togglePopup(true);
  };

  const editAddPD = (q) => {
    setContent(q);
    setFormType("PD");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(true)
  };

  const showAddPE = () => {
    setContent("");
    setFormType("PE");
    toggleCreate(true);
    togglePopup(true);
  };

  const editAddPE = (q) => {
    setContent(q);
    setFormType("PE");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(true)
  };

  const showAddNTE = () => {
    setContent("");
    setFormType("NTE");
    toggleCreate(true);
    togglePopup(true);
  };

  const editAddNTE = (q) => {
    setContent(q);
    setFormType("NTE");
    toggleCreate(true);
    togglePopup(true);
    setIsEdit(true)
  };

  const toggleHover = () => {
    // TODO: Implement the funtion later
  };

  let newUser;
  if (isDeleteQuaPopup) {
    // ======= Update user  =======
    newUser = Object.assign({}, user);
    const arr = newUser.qualifications.filter((q) => q._id !== qualificationID);
    newUser.qualifications = arr;
  }

  const delete_over = (e) => {
    console.log(
      document.getElementById(e.target.id).parentNode.parentNode.childNodes[1]
    );
    document
      .getElementById(e.target.id)
      .parentNode.childNodes[1].classList.toggle("cl-bar2");
    document
      .getElementById(e.target.id)
      .parentNode.parentNode.childNodes[1].classList.toggle("cl-box2");
  };

  // Delete Qualification
  // TODO: Refresh card on delete
  const delete_check = (e) => {
    const id = e.target.id;
    deleteQualification(id);
    toggle();
  };

  const deletePD_check = (e) => {
    const id = e.target.id;
    deleteProfessionalDevelopment(id);
    toggle();
  };

  const deleteEx_check = (e) => {
    const id = e.target.id;
    deleteProfessionalExperience(id);
    toggle();
  };

  const deleteReferee_check = (e) => {
    const id = e.target.id;
    deleteRefereeCheck(id);
    toggle();
  };

  const deleteNonTeachingEx_check = (e) => {
    const id = e.target.id;
    deleteNonTeachingExperience(id);
    toggle();
  };

  const changeStringToMonth = (string) => {
    let d = Date.parse(string + "1, 2020");
    return new Date(d).getMonth() + 1;
  };

  const showVerificationStatus = (qual) => {
    const qualsToVerify = [
      "Bachelor of",
      "Master of/in",
      "PhD in",
      "Graduate Diploma of/in",
      "Graduate Certificate in",
    ];
    return qualsToVerify.includes(qual);
  };

  //dynamic "Add New button". isShowBoxFooter receive from props
  // let addMoreButton;
  // if (isShowBoxFooter) {
  //   addMoreButton = (
  //     <div className="profile_can_deliver_bottom">
  //       <hr className="qualification-line-2"></hr>
  //       <div className="resume-container-update-content a">
  //         <Link onClick={showAddQualifications}>
  //           <Icon
  //             name="add"
  //             circular
  //             inverted
  //             color="#3bb4d8"
  //             className="qualification-container-update-icon"
  //           >
  //             {" "}
  //           </Icon>
  //           {"  "}Add New
  //         </Link>
  //       </div>
  //     </div>
  //   );
  // } else {
  //   addMoreButton = null;
  // }

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  useEffect(() => {
    var focus_ref = null
    switch (window.location.hash) {
      case "#updateQualification":
        focus_ref = quali_ref
        break;
      case "#updateExp":
        focus_ref = exp_ref
        break;
      case "#updateReferee":
        focus_ref = referee_ref
        break;
      default:
        break;
    }
    if (focus_ref) {
      console.log('scroll')
      focus_ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [])

  return (
    <div className="teacher-profile-wrapper mt-3">
      {/* ---------------the testing code by Yuan--------------------------------- */}
      {/*The popup components to edit and add information */}
      {isPopup && (
        <QualificationForm
          user={user}
          showPopup={togglePopup}
          //Yuan: confused about the setUser here.
          // addQualification={setUser}
          isCreate={isCreate}
          qualificationID={qualificationID}
          formType={formType}
          content={content}
          toggleLoading={(status) => setIsLoading(status)}
          handleChangeFileDragDrop={handleChangeFileDragDrop}
          certificateFile={certificateFile}
          transcriptFile={transcriptFile}
          evidenceEnrolmentFile={evidenceEnrolmentFile}
          isEdit={isEdit}
          resetAllFilesUpload={resetAllFilesUpload}
        />
      )}
{/* 
      {isQualPopup && (
        <QualificationModal
          user={user}
          showPopup={toggleQualPopup}
          isCreate={isCreate}
          qualificationID={qualificationID}
          formType={formType}
          content={content}
          file={file}
          resetFile={() => setFile(null)}
          isUploadDrive={isUploadDrive}
          fileFromDrive={fileFromDrive}
          toggleLoading={(status) => setIsLoading(status)}
        />
      )} */}
      <div className="container p-0">
        <div className="row">
          <div className="col-lg-6">
            <span ref={quali_ref}></span>
            {/*Qualifications Box */}
            {/* <ProfileBox header="Qualifications" footer={addMoreButton } > */}
            <ProfileBox
              header="Qualifications"
              footer={
                isViewAsTeacher && (
                  <span onClick={showAddQualifications}>
                    <Icon
                      name="add"
                      circular
                      inverted
                      color="#3bb4d8"
                      className="qualification-container-update-icon"
                    >
                      {" "}
                    </Icon>
                    {"  "}Add New
                  </span>
                )
              }
            >
              {/* { 
                isViewAsTeacher &&
                  <ImportGoogleDriveFile
                    handleSelectFile={handleSelectFile}
                  /> 
              } */}

              {/* {
                isViewAsTeacher &&
                  <DragDropFile
                    file={file}
                    user={user}
                    qualificationType="elt-qualification"
                    handleChangeFileDrag={handleChangeFileDrag}
                  /> 
              } */}

              {user.qualifications && user.qualifications.length > 0
                ?
                <ul className="container p-0">
                  {user.qualifications.map(q => ({...q, type: 'qualification'})).concat(
                    user.vet_training_quals.map(q => ({...q, type: 'vet_training_quals'})),
                    user.vet_industry_quals.map(q => ({...q, type: 'vet_industry_quals'}))
                  ).sort((a, b) => {
                      let dateA, dateB;
                      dateA = a.graduation_date === "Present" ? moment() : moment(a.graduation_date, "MM/YYYY")
                      dateB = b.graduation_date === "Present" ? moment() : moment(b.graduation_date, "MM/YYYY")
                      return dateB.diff(dateA)
                    })
                    .map((q, index, array) => {
                      return (
                        <li key={q._id} className="row">
                          <div className="col-8">
                            <p className="mb-2 profile-qualification-title text-left">
                              {q?.status === "approved" ? <VerifiedUserOutlinedIcon sx={{color: 'green'}} /> : <VerifiedUserOutlinedIcon/>}
                              {q.award_name ? q.award_name : q.degree}
                            </p>
                            {q.major ?
                              <p className="mb-2 profile-qualification-title text-left">
                                ({q.major})
                              </p>
                              : ""}
                            <p className="mb-2 profile-qualification-place text-left">
                              {q.institution_name}{q.institution_city ? `, ${q.institution_city}` : ''}{q.institution_country ? `, ${q.institution_country}` : ''}
                            </p>

                            <p className="profile-qualification-place text-left">
                              <Icon
                                name="file text outline"
                                onClick={() => editAddQualifications(q)}
                                className="qualification-container-update-icon"
                              >
                                {" "}
                              </Icon>
                              {q.graduation_date === "Present" ? (
                                // {q.enrolment_url ? (
                                <Link
                                  to={{
                                    // pathname: `https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/${
                                    // q.enrolment_url.split(".com/")[1]
                                    pathname: `/NavigateToFileViewer?fileurl=${q.enrolment_url
                                      }`,
                                  }}

                                  target="_blank"
                                  className="profile-qualification-place"
                                >
                                  SOE
                                </Link>
                                // <a href={q.enrolment_url} target="_blank">
                                //   <text className="profile-qualification-place">
                                //     SOE
                                //   </text>
                                // </a>
                              ) : (
                                <>
                                  {q.qualification_url ? (
                                    <Link
                                      to={{
                                        // pathname: `https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/${
                                        //   q.qualification_url.split(
                                        //     ".com/"
                                        //   )[1]
                                        pathname: `/NavigateToFileViewer?fileurl=${q.qualification_url
                                          }`,
                                      }}
                                      target="_blank"
                                      className="profile-qualification-place"
                                    >
                                      Certificate
                                    </Link>
                                    // <a href={q.qualification_url}  target="_blank">
                                    //   <text  className="profile-qualification-place">
                                    //     Certificate
                                    //   </text>
                                    // </a>
                                  ) : (
                                    ""
                                  )}
                                  {q.qualification_url && q.transcript_url
                                    ? " | "
                                    : ""}
                                  {q.transcript_url ? (
                                    <Link
                                      to={{
                                        // pathname: `https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/${
                                        //   q.transcript_url.split(".com/")[1]
                                        pathname: `/NavigateToFileViewer?fileurl=${q.transcript_url
                                          }`,
                                      }}
                                      target="_blank"
                                      className="profile-qualification-place"
                                    >
                                      Transcript
                                    </Link>
                                    // <a href={q.transcript_url} target="_blank">
                                    //   <text  className="profile-qualification-place">
                                    //     Transcript
                                    //   </text>
                                    // </a>
                                  ) : (
                                    ""
                                  )}
                                </>
                              )}
                            </p>



                          </div>

                          <div className="col-4">
                            <p className="mt-0 mb-0 profile-qualification-title text-right">
                              {/* {q.graduation_date !== "Present" ? (
                                q.graduation_date.length === 7 ? (
                                  months[
                                  new Date(
                                    q.graduation_date.substring(0, 2) +
                                    "/01/2020"
                                  ).getMonth()
                                  ] +
                                  " " +
                                  new Date(
                                    "01/01/" +
                                    q.graduation_date.substring(3, 10)
                                  ).getFullYear()
                                ) : (
                                  months[
                                  new Date(q.graduation_date).getMonth()
                                  ] +
                                  " " +
                                  new Date(q.graduation_date).getFullYear()
                                )
                              ) : (
                                <p className="mt-0 mb-0 profile-qualification-title text-right">
                                  Currently Enrolled
                                </p>
                              )} */}
                              {q.graduation_date === "Present" ?
                                "Currently Enrolled"
                                :
                                moment(q.graduation_date, "MM/YYYY").format("MMM YYYY")
                              }
                            </p>
                            {isViewAsTeacher ? (
                              <p className="mb-0 profile-qualification-title text-right mt-2">
                                <Icon
                                  name="pencil"
                                  circular
                                  inverted
                                  color="#3bb4d8"
                                  onClick={() => editAddQualifications(q)}
                                  className="qualification-container-update-icon"
                                >
                                  {" "}
                                </Icon>
                                <Icon
                                  name="trash"
                                  circular
                                  inverted
                                  color="grey"
                                  onClick={() => {
                                    setQTarget(q)
                                    setQType(q.type)
                                    toggle(true)
                                  }}
                                  className="qualification-container-update-icon"
                                >
                                  {" "}
                                </Icon>
                              </p>
                            ) : null}
                          </div>
                          {index !== array.length - 1 && (
                            <div className="col-12">
                              <hr className="qualification-line-1 my-3"></hr>
                            </div>
                          )}
                        </li>
                      );
                    })
                  }
                </ul>
                : null}
            </ProfileBox>

            {/* professional development */}
            <ProfileBox
              header="Professional Development"
              footer={
                isViewAsTeacher && (
                  <span onClick={showAddPD}>
                    <Icon
                      name="add"
                      circular
                      inverted
                      color="#3bb4d8"
                      className="qualification-container-update-icon"
                    >
                      {" "}
                    </Icon>
                    {"  "}Add New
                  </span>
                )
              }
            >
              {user.professional_developments.length > 0
                ?
                <ul className="container p-0">
                  {user.professional_developments
                    .sort((a, b) => {
                      let dateA = a.end_date === "Present" ? moment() : moment(a.end_date, "MM/YYYY")
                      let dateB = b.end_date === "Present" ? moment() : moment(b.end_date, "MM/YYYY")
                      return dateB.diff(dateA)
                    })
                    .map((q, index, array) => {
                      return (
                        <li key={q._id} className="p-0">
                          <div className="row">
                            <div className="col-8">
                              <p className="mb-2 profile-qualification-title text-left">
                                {q.activity}
                              </p>
                              <p className="mb-2 profile-qualification-place text-left">
                                {q.focus_event}
                              </p>
                              <p className="profile-qualification-place text-left">
                                {q.location}{q.institution_city ? `, ${q.institution_city}` : ''}{q.institution_country ? `, ${q.institution_country}` : ''}
                              </p>
                            </div>

                            <div className="col-4">
                              <p className="mt-0 mb-0 profile-qualification-title text-right">
                                {q.end_date === "Present" ?
                                  "Currently Enrolled"
                                  :
                                  // (q.end_date.length === 7
                                  //   ? months[
                                  //   new Date(
                                  //     q.end_date.substring(0, 2) + "/01/2020"
                                  //   ).getMonth()
                                  //   ] +
                                  //   " " +
                                  //   new Date(
                                  //     "01/01/" + q.end_date.substring(3, 10)
                                  //   ).getFullYear()
                                  //   : months[new Date(q.end_date).getMonth()] +
                                  //   " " +
                                  //   new Date(q.end_date).getFullYear())
                                  moment(q.end_date, "MM/YYYY").format("MMM YYYY")
                                }
                              </p>

                              {isViewAsTeacher ? (
                                <p className="mb-0 profile-qualification-title text-right mt-2">
                                  <Icon
                                    name="pencil"
                                    circular
                                    inverted
                                    color="#3bb4d8"
                                    onClick={() => editAddPD(q)}
                                    className="qualification-container-update-icon"
                                  >
                                    {" "}
                                  </Icon>
                                  <Icon
                                    name="trash"
                                    circular
                                    inverted
                                    color="grey"
                                    onClick={() => {
                                      setQTarget(q)
                                      setQType('prof_dev')
                                      toggle(true)
                                    }}
                                    className="qualification-container-update-icon"
                                  // id={q._id}
                                  >
                                    {" "}
                                  </Icon>
                                </p>
                              ) : null}
                            </div>
                            {index !== array.length - 1 && (
                              <div className="col-12">
                                <hr className="qualification-line-1 my-3"></hr>
                              </div>
                            )}
                          </div>
                        </li>
                      );
                    })
                  }
                </ul>
                : null}
            </ProfileBox>

            {/* Police & Children Checks */}
            <ProfileBox header='Police & Children Checks'>
              <div>{displayPoliceCheckWwCC}</div>
            </ProfileBox>
          </div>

          <div className="col-lg-6">
            <div className="experience">
              <TeacherHours user={user} />
              {user.professional_experience.length > 0 && !user?.is_childhood_teacher ? (
                user.level === teacherLevel.SENIOR ? (
                  <img
                    className="teacher-level-badge-v2"
                    src={require("../../assets/img/seniorBadge.png")}
                    alt="senior badge"
                  />
                ) : user.level === teacherLevel.EXPERT ? (
                  <img
                    className="teacher-level-badge-expert"
                    src={require("../../assets/img/expert.png")}
                    alt="expert badge"
                  />
                ) : user.level === teacherLevel.MASTER ? (
                  <img
                    className="teacher-level-badge-expert"
                    src={require("../../assets/img/master.png")}
                    alt="master badge"
                  />
                ) : <img
                      className="teacher-level-badge-v2"
                      src={require("../../assets/img/juniorBadge.png")}
                      alt="junior badge"
                    />
              ) : null}
            </div>
            <div>
              {/*  Teaching Experience*/}
              <span ref={exp_ref}></span>
              <ProfileBox
                header="Teaching Experience"
                footer={
                  isViewAsTeacher && (
                    <span onClick={showAddPE}>
                      <Icon
                        name="add"
                        circular
                        inverted
                        color="#3bb4d8"
                        className="qualification-container-update-icon"
                      >
                        {" "}
                      </Icon>
                      {"  "}Add New
                    </span>
                  )
                }
              >
                {user.professional_experience.length > 0
                  ?
                  <ul className="container p-0">
                    {user.professional_experience
                      .sort((a, b) => {
                        let dateA, dateB;
                        if (a.end_date === b.end_date) {
                          dateA = moment(a.start_date, "MM/YYYY");
                          dateB = moment(b.start_date, "MM/YYYY");
                        }
                        else {
                          dateA = a.end_date === "Present" ? moment() : moment(a.end_date, "MM/YYYY")
                          dateB = b.end_date === "Present" ? moment() : moment(b.end_date, "MM/YYYY")
                        }
                        return dateB.diff(dateA)
                      })
                      .map((q, index, array) => {
                        return (
                          <li key={q._id} className="p-0">
                            <div className="row">
                              <div className="col-8">
                                {/* <p className="mt-0 mb-0 profile-qualification-title text-left">{q.graduation_date}</p> */}
                                <p className="mt-0 mb-2 profile-qualification-title text-left">
                                  {q.organisation}
                                </p>
                                <p className="mt-0 mb-2 profile-qualification-place text-left">
                                  {q.institution_city ? `${q.institution_city}` : ''}{q.institution_country ? `, ${q.institution_country}` : ''}
                                </p>
                                <p className="profile-qualification-place text-left">
                                  {q.course_class_delivered.length > 0
                                    ? q.course_class_delivered
                                      .map((item) => item.value)
                                      .join(" | ")
                                    : q.course_class_delivered}
                                </p>
                                {q.qualification_url ? (
                                  q.qualification_status ? (
                                    <p className="mt-2 profile-qualification-place text-left">
                                      <i className="mdi mdi-checkbox-marked-circle float-righte green"></i>
                                      Verified
                                    </p>
                                  ) : (
                                    <p className="mt-2 profile-qualification-place text-left red">
                                      Awaiting Verification
                                    </p>
                                  )
                                ) : null}
                                {
                                  q?._id === "dc1837d9-d5d8-40b7-b8e5-e931a90065e5" && (
                                    <div className="profile-qualification-place text-left">
                                      English for Academic Purposes (16 week
                                      program): EAP course for EFL teacher
                                      candidates in the first year of their program.
                                      Course focus: academic writing & writing skill
                                      development, such as mastering paragraph
                                      writing through a process-oriented approach.
                                      Students learned to create diverse paragraph
                                      types and effectively connect them in cohesive
                                      essays.
                                    </div>
                                  )
                                }
                                {
                                  q?._id === "c7a1e94e-2d2e-4c80-9aeb-57f691c4b7c7" && (
                                    <div className="profile-qualification-place text-left">
                                      Deliver two-year HSP course to Year 11 & 12 students on various genres of writing including poetry, prose and essay writing.
                                    </div>
                                  )
                                }
                                {
                                  q?._id === "424fb6b0-e715-4dbc-bf03-abbc51497caf" && (
                                    <div className="profile-qualification-place text-left">
                                      Deliver a 10-week course aimed at development of test taking strategies and improve TOEFL test score to enable learners to apply for postgraduate scholarships
                                    </div>
                                  )
                                }
                                {
                                  q?._id === "4a3d6956-4219-435c-9e42-af50f9cbb91c" && (
                                    <div className="profile-qualification-place text-left">
                                      12-week course aimed at TOEFL test score improvement to enable learners to apply for postgraduate scholarships. Included Paragraph Writing, Essay Writing, Referencing, Paraphrasing skill.
                                    </div>
                                  )
                                }
                                {
                                  q?._id === "20291402-64ff-4b35-83c9-1c1fe35ad0e7" && (
                                    <div className="profile-qualification-place text-left">
                                      Various EAP courses exploring dimensions of Qualitative Research including reflective studies, classroom oriented research, case studies, narrative inquiries, diary studies, etc.; collecting, compiling, and analysing diverse types of research data; various academic texts such as book review article, classroom idea article, original research article, position article, practice based article and reflection based article; reading strategies to comprehend academic texts reading; analyse academic writing in terms of grammar, content, genre, pattern of development, and stylistic features;  experience delivering ceremonial, informative, and persuasive speeches; develop analytical and critical listening skills.
                                    </div>
                                  )
                                }
                                {
                                  q?._id === "a074ba24-3a15-4b6c-95a4-37c9f74efa49" && (
                                    <div className="profile-qualification-place text-left">
                                      Research skills, plagiarism, reference writing and citation, working on academic vocabulary and grammar (structures), how to prepare presentations and public speaking skills. Paraphrasing and summarising academic texts, and familiarising students with marking procedures. Academic discussions, how to write assignments and essays for academic purposes, even how to ask questions in academic contexts.
                                    </div>
                                  )
                                }
                                {
                                  q?._id === "06ee2ced-68b0-4d3c-8c90-6970e616ceca" && (
                                    <div className="profile-qualification-place text-left">
                                      EAP Bridging courses including content-based instruction from degree subjects. Course length varied from 5 to 40 weeks. Advanced EAP, effective communication, ethical attitude, academic enquiry and analysis engagement, building debating skills, understanding literary texts of different genres and periods, acquiring critical approach and study skills, developing note-taking and referencing skills.
                                    </div>
                                  )
                                }
                              </div>
                              <div className="col-4">
                                <p className="mt-0 mb-0 profile-qualification-title text-right">
                                  {/* {q.end_date.length === 7 &&
                                    q.start_date.length === 7
                                    ? months[
                                    new Date(
                                      q.start_date.substring(0, 2) +
                                      "/01/2020"
                                    ).getMonth()
                                    ] +
                                    " " +
                                    new Date(
                                      "01/01/" + q.start_date.substring(3, 10)
                                    ).getFullYear() +
                                    " - " +
                                    (q.end_date !== "Present"
                                      ? months[
                                      new Date(
                                        q.end_date.substring(0, 2) +
                                        "/01/2020"
                                      ).getMonth()
                                      ]
                                      : q.end_date) +
                                    " " +
                                    (q.end_date !== "Present"
                                      ? new Date(
                                        "01/01/" +
                                        q.end_date.substring(3, 10)
                                      ).getFullYear()
                                      : "")
                                    : months[
                                    new Date(q.start_date).getMonth()
                                    ] +
                                    " " +
                                    new Date(q.start_date).getFullYear() +
                                    "-" +
                                    (q.end_date !== "Present"
                                      ? months[
                                      new Date(q.end_date).getMonth()
                                      ]
                                      : q.end_date) +
                                    (q.end_date !== "Present"
                                      ? new Date(q.end_date).getFullYear()
                                      : "")} */}
                                  {q?._id === "dc1837d9-d5d8-40b7-b8e5-e931a90065e5" ? "Jan 2009 - Dec 2011" : 
                                  moment(q.start_date, "MM/YYYY").format("MMM YYYY")
                                    + " - " +
                                    (q.end_date === "Present" ? q.end_date : moment(q.end_date, "MM/YYYY").format("MMM YYYY"))
                                  }
                                </p>
                                {isViewAsTeacher ? (
                                  <p className="mb-0 profile-qualification-title text-right mt-2">
                                    <Icon
                                      name="pencil"
                                      circular
                                      inverted
                                      color="#3bb4d8"
                                      onClick={() => editAddPE(q)}
                                      className="qualification-container-update-icon"
                                    >
                                      {" "}
                                    </Icon>
                                    <Icon
                                      name="trash"
                                      circular
                                      inverted
                                      color="grey"
                                      onClick={() => {
                                        setQTarget(q)
                                        setQType('tech_exp')
                                        toggle(true)
                                      }}
                                      className="qualification-container-update-icon"
                                    >
                                      {" "}
                                    </Icon>
                                  </p>
                                ) : null}
                              </div>
                              {index !== array.length - 1 && (
                                <div className="col-12">
                                  <hr className="qualification-line-1 my-3"></hr>
                                </div>
                              )}
                            </div>
                          </li>
                        );
                      })
                    }
                  </ul>
                  : null}
              </ProfileBox>
            </div>

            <div>
              {/*  OTHER PROFESSIONAL EXPERIENCE*/}
              <ProfileBox
                header="Other Experience"
                footer={
                  isViewAsTeacher && (
                    <span onClick={showAddNTE}>
                      <Icon
                        name="add"
                        circular
                        inverted
                        color="#3bb4d8"
                        className="qualification-container-update-icon"
                      >
                        {" "}
                      </Icon>
                      {"  "}Add New
                    </span>
                  )
                }
              >
                {user.non_teaching_experience.length > 0
                  ?
                  <ul className="container p-0">
                    {user.non_teaching_experience
                      .sort((a, b) => {
                        let dateA, dateB;
                        if (a.end_date === b.end_date) {
                          dateA = moment(a.start_date, "MM/YYYY");
                          dateB = moment(b.start_date, "MM/YYYY");
                        }
                        else {
                          dateA = a.end_date === "Present" ? moment() : moment(a.end_date, "MM/YYYY")
                          dateB = b.end_date === "Present" ? moment() : moment(b.end_date, "MM/YYYY")
                        }
                        return dateB.diff(dateA)
                      })
                      .map((q, index, array) => {
                        let main_duties = q.main_duties.split(" ");
                        if (main_duties.length > 75) {
                          main_duties = main_duties.slice(0, 75).join(" ") + " ..."
                        }
                        else {
                          main_duties = q.main_duties;
                        }
                        return (
                          <li key={q._id} className="p-0">
                            <div className="row">
                              <div className="col-8">
                                <p className="mt-0 mb-2 profile-qualification-title text-left">
                                  {q.role_held}
                                </p>
                                <p className="mt-0 mb-2 profile-qualification-place text-left">
                                  {main_duties}
                                </p>
                                <p className="profile-qualification-place text-left">
                                  {q.organisation + ", "}
                                  {q.institution_city ? `${q.institution_city}` : ''}{q.institution_country ? `, ${q.institution_country}` : ''}
                                </p>
                              </div>

                              <div className="col-4">
                                <p className="mt-0 mb-0 profile-qualification-title text-right">
                                  {/* {q.end_date.length === 7 &&
                                    q.start_date.length === 7
                                    ? months[
                                    new Date(
                                      q.start_date.substring(0, 2) +
                                      "/01/2020"
                                    ).getMonth()
                                    ] +
                                    " " +
                                    new Date(
                                      "01/01/" + q.start_date.substring(3, 10)
                                    ).getFullYear() +
                                    " - " +
                                    (q.end_date !== "Present"
                                      ? months[
                                      new Date(
                                        q.end_date.substring(0, 2) +
                                        "/01/2020"
                                      ).getMonth()
                                      ]
                                      : q.end_date) +
                                    " " +
                                    (q.end_date !== "Present"
                                      ? new Date(
                                        "01/01/" +
                                        q.end_date.substring(3, 10)
                                      ).getFullYear()
                                      : "")
                                    : months[
                                    new Date(q.start_date).getMonth()
                                    ] +
                                    " " +
                                    new Date(q.start_date).getFullYear() +
                                    " - " +
                                    (q.end_date !== "Present"
                                      ? months[
                                      new Date(q.end_date).getMonth()
                                      ]
                                      : q.end_date) +
                                    " " +
                                    (q.end_date !== "Present"
                                      ? new Date(q.end_date).getFullYear()
                                      : "")} */}
                                  {moment(q.start_date, "MM/YYYY").format("MMM YYYY")
                                    + " - " +
                                    (q.end_date === "Present" ? q.end_date : moment(q.end_date, "MM/YYYY").format("MMM YYYY"))
                                  }
                                </p>
                                {isViewAsTeacher ? (
                                  <p className="mb-0 profile-qualification-title text-right mt-2">
                                    <Icon
                                      name="pencil"
                                      circular
                                      inverted
                                      color="#3bb4d8"
                                      onClick={() => editAddNTE(q)}
                                      className="qualification-container-update-icon"
                                    >
                                      {" "}
                                    </Icon>
                                    <Icon
                                      name="trash"
                                      circular
                                      inverted
                                      color="grey"
                                      onClick={() => {
                                        setQTarget(q)
                                        setQType('other_pro_exp')
                                        toggle(true)
                                      }}
                                      className="qualification-container-update-icon"
                                    >
                                      {" "}
                                    </Icon>
                                  </p>
                                ) : null}
                              </div>
                              {index !== array.length - 1 && (
                                <div className="col-12">
                                  <hr className="qualification-line-1 my-3"></hr>
                                </div>
                              )}
                            </div>
                          </li>
                        );
                      })
                    }
                  </ul>
                  : null}
              </ProfileBox>
            </div>
            
            <div>
              {/*  PROFESSIONAL REFEREE*/}
              {props.isViewAsTeacher && (
                <>
                  <span ref={referee_ref}></span>
                  <ProfileBox
                    header="Professional Referee"
                    footer={
                      isViewAsTeacher && (!user.referees || user.referees.length < 2) && (
                        <span onClick={() => showAddReferee()}>
                          <Icon
                            name="add"
                            circular
                            inverted
                            color="#3bb4d8"
                            className="qualification-container-update-icon"
                          >
                            {" "}
                          </Icon>
                          {"  "}Add New
                        </span>
                      )
                    }
                  >
                    {user.referees.length > 0
                      ?
                      <ul className="container p-0">
                        {user.referees.map((q, index, array) => {
                          return (
                            <li key={q._id} className="p-0">
                              <div className="row">
                                <div className="col-8">
                                  <p className="mt-0 mb-2 profile-qualification-title text-left">
                                    {q.organisation}
                                  </p>
                                  <p className="mt-0 mb-2 profile-qualification-place text-left">
                                    {q.referee_first_name +
                                      " " +
                                      q.referee_last_name +
                                      "  (" +
                                      q.referee_position_title +
                                      ")"}
                                  </p>
                                  <p className="profile-qualification-place text-left">
                                    {q.referee_email}
                                  </p>
                                </div>

                                {isViewAsTeacher ? (
                                  <div className="col-4">
                                    <p className="mb-0 profile-qualification-title text-right mt-2">
                                      <Icon
                                        name="pencil"
                                        circular
                                        inverted
                                        color="#3bb4d8"
                                        onClick={() => showAddReferee(q)}
                                        className="qualification-container-update-icon"
                                      >
                                        {" "}
                                      </Icon>
                                      <Icon
                                        name="trash"
                                        circular
                                        inverted
                                        color="grey"
                                        onClick={() => {
                                          setQTarget(q)
                                          setQType('pro_refree')
                                          toggle(true)
                                        }}
                                        className="qualification-container-update-icon"
                                      >
                                        {" "}
                                      </Icon>
                                    </p>
                                  </div>
                                ) : null}
                                <hr className="qualification-line-1"></hr>
                              </div>
                            </li>
                          );
                        })
                        }
                      </ul>
                      : null}
                  </ProfileBox>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="confirm-delete"
        header="Do you wish to delete?"
        show={isShowing}
        onClose={toggle}
      >
        <div className="row m-0">
          <div className="col-md-6">
            <CancelButton
              type="button"
              onClick={toggle}
            >
              Cancel
            </CancelButton>
          </div>
          <div className="col-md-6 padding-for-mobile">
            <ConfirmButton
              type="button"
              onClick={delete_confirm}
              id={'q._id'}
            >
              Yes and Proceed
            </ConfirmButton>
          </div>
        </div>
      </Modal>

      <Backdrop
        sx={{ color: '#fff', zIndex: 1200 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  deleteQualification: (user) => dispatch(deleteQualification(user)),
  deleteProfessionalDevelopment: (user) =>
    dispatch(deleteProfessionalDevelopment(user)),
  deleteProfessionalExperience: (user) =>
    dispatch(deleteProfessionalExperience(user)),
  deleteRefereeCheck: (user) => dispatch(deleteRefereeCheck(user)),
  deleteNonTeachingExperience: (user) =>
    dispatch(deleteNonTeachingExperience(user)),
});

export default connect(null, mapDispatchToProps)(TeacherResume);
